// IMPORTANT: Dynamic checkout buttons (Buy Now, Apple Pay, Google Pay) bypass
// the product form and will NOT capture birth data. Merchants should hide
// these buttons on astrology report products. Add this CSS to the theme:
//   .shopify-payment-button { display: none !important; }
// Or use product metafields to conditionally hide them.
(function () {
  "use strict";

  // ─── Configuration constants ───────────────────────────────────────
  var DEBOUNCE_MS = 300;
  var MIN_QUERY_LENGTH = 2;
  var MAP_ZOOM_DEFAULT = 10;
  var LEAFLET_CSS_URL = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
  var LEAFLET_JS_URL = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
  var TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
  var TILE_ATTRIBUTION =
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';
  var MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // ─── Locale bundle (multibrand 10b-i plan D3) ──────────────────────
  // Every customer-visible string resolves config-first from the JSON block
  // the Liquid host renders (#astro-birth-form-config, locale-catalog-fed),
  // falling back per key to the byte-identical EN literals below — a
  // missing or malformed config degrades to English, never a broken buy
  // path. EN_DEFAULT is the ONLY place these literals may live (offline
  // test-pinned); [bracket] tokens are substituted by fillTemplate. The
  // canonical property keys (properties[_client_name] etc.) are wire
  // contract, never localized, and never part of this bundle.
  var EN_DEFAULT = {
    property_client_name: "Client Name",
    property_birth_date: "Birth Date",
    property_birth_time: "Birth Time",
    property_birth_place: "Birth Place",
    label_name: "Name for the reading",
    placeholder_name: "First name is enough",
    legend_birth_date: "Birth Date",
    label_month: "Month",
    label_day: "Day",
    label_year: "Year",
    option_month: "Month",
    placeholder_day: "DD",
    placeholder_year: "YYYY",
    month_1: MONTH_NAMES[0], month_2: MONTH_NAMES[1], month_3: MONTH_NAMES[2],
    month_4: MONTH_NAMES[3], month_5: MONTH_NAMES[4], month_6: MONTH_NAMES[5],
    month_7: MONTH_NAMES[6], month_8: MONTH_NAMES[7], month_9: MONTH_NAMES[8],
    month_10: MONTH_NAMES[9], month_11: MONTH_NAMES[10], month_12: MONTH_NAMES[11],
    date_human: "[month] [day], [year]",
    label_birth_time: "Birth Time",
    label_hour: "Hour",
    label_minute: "Minute",
    label_ampm: "AM/PM",
    option_hr: "Hr",
    option_min: "Min",
    option_ampm: "AM/PM",
    option_am: "AM",
    option_pm: "PM",
    aria_birth_hour: "Birth hour",
    aria_birth_minute: "Birth minute",
    aria_am_pm: "AM or PM",
    time_hint_html:
      'Within 5 minutes is excellent, within 15 is still good. If you truly can\'t find it, our <a href="[essential_url]">Essential report</a> is built exactly for that.',
    label_birth_place: "Birth Place",
    placeholder_birth_place: "Type your birth city...",
    aria_place_results: "Place search results",
    map_open_html: "Can't find your city, or want to fine-tune? Open the map",
    map_close: "Hide the map",
    map_coords_hint: "You can also click the map or drag the pin to select or fine-tune your birth place.",
    map_coords: "Coordinates: [lat]°, [lng]°. Click the map or drag the pin to fine-tune.",
    cta_chart: "Read My Chart",
    cta_essential: "Read My Essential Chart",
    cta_full: "Read My Full Chart",
    cta_adding: "Adding...",
    cta_added: "Added!",
    submit_hint: "Fill in your details above to continue",
    missing_name: "the name for the reading",
    missing_date: "the birth date",
    missing_time: "the birth time",
    missing_place: "the birth place",
    error_name: "Add the name the reading is for. A first name is enough.",
    error_date_fallback: "Add the birth date.",
    error_time: "Pick the hour, minute, and AM/PM of birth.",
    error_place_pick: "Almost there: pick your city from the suggestion list, or set it on the map.",
    error_place_add: "Add the birth city, then pick it from the suggestion list.",
    still_needed_one: "Still needed: [item].",
    still_needed_many: "Still needed: [items] and [last].",
    list_separator: ", ",
    error_date_required: "Birth Date is required.",
    error_date_real: "Birth Date must be a real date.",
    error_date_digits: "Birth Date day and year must use numbers only.",
    error_date_year4: "Birth Date year must include 4 numbers.",
    error_date_future: "Birth Date cannot be in the future.",
    geo_error: "City search hit a snag. Type again in a moment, or set your birth place on the map below.",
    geo_no_matches: "No matches. Check the spelling, try the nearest larger town, or drop a pin on the map below.",
    geo_no_matches_sr: "No matches. Check the spelling, try the nearest larger town, or use the map.",
    geo_closest: "Closest matches:",
    sr_results: "[count] results. Top match: [place]. Press Enter to select it.",
    sr_location_set: "Location set to [place]",
    sr_pin_reset: "That spot could not be matched to a town, so the pin was reset. Try again, or type your birth city above.",
    alert_variant: "Error: Could not find product variant. Please refresh and try again.",
    alert_add_prefix: "Error placing order:",
    error_add_failed: "Failed to add to cart",
    typically_1h: "Typically within 1 hour",
    refund_14: "14-day refund",
  };

  function fillTemplate(template, params) {
    var out = String(template);
    Object.keys(params).forEach(function (key) {
      out = out.split("[" + key + "]").join(String(params[key]));
    });
    return out;
  }

  function loadFormConfig() {
    try {
      var el = document.getElementById("astro-birth-form-config");
      if (!el) return {};
      var parsed = JSON.parse(el.textContent);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
      return {}; // malformed config: degrade to EN, keep the buy path alive
    }
  }

  function makeT(config) {
    var strings = config && config.strings && typeof config.strings === "object" ? config.strings : {};
    return function t(key) {
      var value = strings[key];
      return typeof value === "string" ? value : EN_DEFAULT[key];
    };
  }

  function pad2(value) {
    return String(value).padStart(2, "0");
  }

  function getTodayIsoDate() {
    var today = new Date();
    return (
      today.getFullYear() +
      "-" +
      pad2(today.getMonth() + 1) +
      "-" +
      pad2(today.getDate())
    );
  }

  function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  }

  function daysInMonth(year, month) {
    if (month === 2) return isLeapYear(year) ? 29 : 28;
    if (month === 4 || month === 6 || month === 9 || month === 11) return 30;
    return 31;
  }

  // locale (optional): { t, dateLabel } — t resolves catalog strings for
  // the error messages, month names and the [month] [day], [year] display
  // template; dateLabel is the LOCALIZED visible date property label. The
  // defaults reproduce today's EN behavior byte-for-byte (tests construct
  // the factory bare). The ISO property key is wire contract, never varies.
  function createBirthDateHelpers(todayProvider, locale) {
    var getToday = todayProvider || getTodayIsoDate;
    var t = (locale && locale.t) || function (key) { return EN_DEFAULT[key]; };
    var dateLabel = (locale && locale.dateLabel) || EN_DEFAULT.property_birth_date;
    var visibleName = "properties[" + dateLabel + "]";

    function parseBirthDateParts(parts) {
      var monthValue = (parts.month || "").trim();
      var dayValue = (parts.day || "").trim();
      var yearValue = (parts.year || "").trim();

      if (!monthValue || !dayValue || !yearValue) {
        return { ok: false, iso: "", human: "", error: t("error_date_required") };
      }
      if (!/^\d+$/.test(monthValue)) {
        return { ok: false, iso: "", human: "", error: t("error_date_real") };
      }
      if (!/^\d+$/.test(dayValue) || !/^\d+$/.test(yearValue)) {
        return {
          ok: false,
          iso: "",
          human: "",
          error: t("error_date_digits"),
        };
      }
      if (!/^\d{4}$/.test(yearValue)) {
        return {
          ok: false,
          iso: "",
          human: "",
          error: t("error_date_year4"),
        };
      }

      var month = parseInt(monthValue, 10);
      var day = parseInt(dayValue, 10);
      var year = parseInt(yearValue, 10);
      if (year < 1 || month < 1 || month > 12 || day < 1 || day > daysInMonth(year, month)) {
        return { ok: false, iso: "", human: "", error: t("error_date_real") };
      }

      var iso = yearValue + "-" + pad2(month) + "-" + pad2(day);
      if (iso > getToday()) {
        return {
          ok: false,
          iso: "",
          human: "",
          error: t("error_date_future"),
        };
      }

      return {
        ok: true,
        iso: iso,
        human: fillTemplate(t("date_human"), {
          month: t("month_" + month),
          day: String(day),
          year: yearValue,
        }),
        error: "",
      };
    }

    function buildBirthDateProperties(parts) {
      var parsed = parseBirthDateParts(parts);
      if (!parsed.ok) {
        return {
          ok: false,
          visible: { name: visibleName, value: "" },
          iso: { name: "properties[_birth_date_iso]", value: "" },
          error: parsed.error,
        };
      }
      return {
        ok: true,
        visible: { name: visibleName, value: parsed.human },
        iso: { name: "properties[_birth_date_iso]", value: parsed.iso },
        error: "",
      };
    }

    return {
      parseBirthDateParts: parseBirthDateParts,
      buildBirthDateProperties: buildBirthDateProperties,
    };
  }

  // Per-locale time-input mode (REC-1): the catalog token
  // wd.form.time_format rides the config block as top-level metadata;
  // anything but exactly "24h" degrades to the 12-h EN behavior (missing
  // or malformed config never breaks the buy path). buildValue is the
  // SINGLE writer of the hidden time value in both modes and enforces the
  // wire grammar strictly — zero-padded 24-h "HH:MM" or "" (the backend
  // contract; docs/reference/birth-data-widget.md). Hour 0 = midnight IS
  // valid 24-h input: the 12-h truthiness idiom must never leak into the
  // 24-h branch (test-pinned).
  function createBirthTimeHelpers(mode) {
    var is24h = mode === "24h";
    var TWO_DIGITS = /^\d{1,2}$/;

    function buildValue(hourStr, minuteStr, ampmStr) {
      var h = String(hourStr == null ? "" : hourStr);
      var m = String(minuteStr == null ? "" : minuteStr);
      if (!TWO_DIGITS.test(h) || !TWO_DIGITS.test(m)) return "";
      var hour = parseInt(h, 10);
      var minute = parseInt(m, 10);
      if (minute > 59) return "";
      if (is24h) {
        if (hour > 23) return "";
      } else {
        if (hour < 1 || hour > 12) return "";
        if (ampmStr === "AM") {
          if (hour === 12) hour = 0;
        } else if (ampmStr === "PM") {
          if (hour !== 12) hour = hour + 12;
        } else {
          return "";
        }
      }
      return pad2(hour) + ":" + pad2(minute);
    }

    return { is24h: is24h, buildValue: buildValue };
  }

  // ─── Utility: debounce ─────────────────────────────────────────────
  function debounce(fn, ms) {
    var timer;
    return function () {
      var ctx = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }

  // ─── Place query helpers (pure, unit-tested) ──────────────────────
  // Normalize what the customer typed before querying: collapse runs of
  // whitespace, strip stray leading/trailing commas and spaces.
  function cleanPlaceQuery(raw) {
    return String(raw || "")
      .replace(/\s+/g, " ")
      .replace(/^[\s,]+|[\s,]+$/g, "");
  }

  function placeDisplayString(place) {
    if (place.display_name) return String(place.display_name);
    var parts = [place.name];
    if (place.admin1) parts.push(place.admin1);
    if (place.country) parts.push(place.country);
    return parts.join(", ");
  }

  // The suggestion whose text the customer already typed IN FULL: either
  // the exact display string ("Amsterdam, North Holland, The Netherlands")
  // or — when opts.nameMatchAllowed is not false — a city name that
  // matches exactly and is unique in the list. Anything ambiguous returns
  // null: auto-accepting a guessed birthplace would silently produce a
  // wrong chart.
  function findExactPlaceMatch(results, text, opts) {
    if (!results || !results.length) return null;
    var typed = cleanPlaceQuery(text).toLowerCase();
    if (!typed) return null;
    for (var i = 0; i < results.length; i++) {
      if (placeDisplayString(results[i]).toLowerCase() === typed) {
        return results[i];
      }
    }
    if (opts && opts.nameMatchAllowed === false) return null;
    var nameMatches = results.filter(function (p) {
      return String(p.name || "").toLowerCase() === typed;
    });
    return nameMatches.length === 1 ? nameMatches[0] : null;
  }

  // ─── Blocked-submit scroll helpers (pure, unit-tested) ─────────────
  // A blocked "Read My Chart" click focuses the first missing field,
  // which opens the phone keyboard. The keyboard covers the bottom of
  // the screen, so a scroll aimed at the middle of the full screen often
  // lands the field behind it. These helpers time the scroll until the
  // keyboard has settled and aim it at the area that stays visible.
  var KEYBOARD_QUIET_MS = 120; // resize silence that counts as settled
  var KEYBOARD_FALLBACK_MS = 250; // no keyboard ever opens (desktop)
  var KEYBOARD_MAX_WAIT_MS = 900; // hard cap; never wait longer

  // Window scroll position that vertically centers a field in the visible
  // (visual) viewport. All values in CSS pixels: rectTop/rectHeight from
  // getBoundingClientRect, viewHeight/viewTop from window.visualViewport
  // (or innerHeight/0 where visualViewport is unavailable).
  function computeCenteredScrollTop(metrics) {
    var margin = (metrics.viewHeight - metrics.rectHeight) / 2;
    if (margin < 0) margin = 0; // field taller than the view: show its top
    var top = metrics.pageYOffset + metrics.rectTop - metrics.viewTop - margin;
    if (!isFinite(top)) return NaN; // caller falls back to scrollIntoView
    return top > 0 ? top : 0;
  }

  // Run callback once the on-screen keyboard has finished opening. The
  // keyboard animates the visual viewport through a burst of resize
  // events, so wait for a quiet gap after the last one. The fallback
  // timer covers the no-keyboard case (desktop, or no visualViewport
  // support), and the max timer guarantees the callback always runs.
  function scheduleAfterKeyboardSettles(win, callback) {
    var vv = win.visualViewport;
    var done = false;
    var quietTimer = null;
    function finish() {
      if (done) return;
      done = true;
      if (quietTimer) clearTimeout(quietTimer);
      if (vv && typeof vv.removeEventListener === "function") {
        vv.removeEventListener("resize", onResize);
      }
      callback();
    }
    function onResize() {
      if (done) return;
      if (quietTimer) clearTimeout(quietTimer);
      quietTimer = setTimeout(finish, KEYBOARD_QUIET_MS);
    }
    if (vv && typeof vv.addEventListener === "function") {
      vv.addEventListener("resize", onResize);
    }
    quietTimer = setTimeout(finish, KEYBOARD_FALLBACK_MS);
    setTimeout(finish, KEYBOARD_MAX_WAIT_MS);
  }

  // ─── Utility: createElement helper ─────────────────────────────────
  function createElement(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (key) {
        if (key === "className") el.className = attrs[key];
        else if (key === "textContent") el.textContent = attrs[key];
        else if (key === "innerHTML") el.innerHTML = attrs[key];
        else if (key.startsWith("on"))
          el.addEventListener(key.slice(2).toLowerCase(), attrs[key]);
        else el.setAttribute(key, attrs[key]);
      });
    }
    if (children) {
      children.forEach(function (child) {
        if (typeof child === "string")
          el.appendChild(document.createTextNode(child));
        else if (child) el.appendChild(child);
      });
    }
    return el;
  }

  // ─── Leaflet loader (CSS + JS from CDN, on demand) ────────────────
  var leafletLoaded = false;
  var leafletCallbacks = [];

  function loadLeaflet(callback) {
    if (leafletLoaded && window.L) {
      callback();
      return;
    }
    leafletCallbacks.push(callback);
    if (leafletCallbacks.length > 1) return; // already loading

    // Prefer the theme-hosted Leaflet copies (injected as data-* attrs by
    // Liquid) so the buy path never depends on a third-party CDN; the
    // constants above remain as a fallback for older cached markup.
    var hostEl = document.getElementById("astro-birth-form");
    var cssUrl = (hostEl && hostEl.getAttribute("data-leaflet-css")) || LEAFLET_CSS_URL;
    var jsUrl = (hostEl && hostEl.getAttribute("data-leaflet-js")) || LEAFLET_JS_URL;

    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = cssUrl;
    document.head.appendChild(link);

    var script = document.createElement("script");
    script.src = jsUrl;
    script.onload = function () {
      leafletLoaded = true;
      // Self-host the marker icons so the widget never depends on unpkg.com
      // loading them (it serves no compressed variants and sometimes 404s).
      // Paths are injected as data-* attrs on the form container by Liquid.
      var host = document.getElementById("astro-birth-form");
      if (window.L && window.L.Icon && window.L.Icon.Default && host) {
        var iconUrl = host.getAttribute("data-marker-icon");
        var iconRetinaUrl = host.getAttribute("data-marker-icon-2x");
        var shadowUrl = host.getAttribute("data-marker-shadow");
        if (iconUrl && iconRetinaUrl && shadowUrl) {
          // Prevent Leaflet from trying to resolve defaults from leaflet.css
          delete window.L.Icon.Default.prototype._getIconUrl;
          window.L.Icon.Default.mergeOptions({
            iconUrl: iconUrl,
            iconRetinaUrl: iconRetinaUrl,
            shadowUrl: shadowUrl,
          });
        }
      }
      leafletCallbacks.forEach(function (cb) {
        cb();
      });
      leafletCallbacks = [];
    };
    script.onerror = function () {
      console.error("Failed to load Leaflet map library");
      leafletCallbacks = [];
    };
    document.head.appendChild(script);
  }

  // ─── Geocoder API client (with AbortController fallback) ──────────
  function createGeocoder(apiBase) {
    var controller = null;
    return function search(query, callback) {
      if (typeof AbortController !== 'undefined') {
        if (controller) controller.abort();
        controller = new AbortController();
      }
      var url = apiBase + "/geocode?q=" + encodeURIComponent(query);
      var fetchOptions = controller ? { signal: controller.signal } : {};
      fetch(url, fetchOptions)
        .then(function (resp) {
          if (!resp.ok) {
            var httpError = new Error("Geocoder error: " + resp.status);
            httpError.status = resp.status;
            throw httpError;
          }
          return resp.json();
        })
        .then(function (data) {
          controller = null;
          callback(null, data);
        })
        .catch(function (err) {
          controller = null;
          if (err.name !== "AbortError") callback(err, []);
        });
    };
  }

  // ─── BirthDataForm widget class ───────────────────────────────────
  BirthDataForm._instanceCount = 0;

  // ─── Funnel milestone tracking (Clarity + Shopify pixel bus) ───────
  // Emits friction beacons like "form started" / "birth date filled" so
  // drop-off inside the widget becomes measurable. HARD RULES: only the
  // event name + report tier ever leave the page — never field content
  // (the birth data itself) — and a tracker failure must never reach the
  // buy path, so every sink call is wrapped. Consent is enforced
  // upstream: the Clarity app embed feeds Shopify's consent signals into
  // Clarity, and Shopify gates pixel-bus subscribers itself.
  function createMilestoneTracker(emit) {
    var seen = {};
    return {
      hit: function (name, data) {
        if (seen[name]) return false;
        seen[name] = true;
        try {
          emit(name, data || {});
        } catch (e) {
          /* tracking must never break the form */
        }
        return true;
      },
    };
  }

  function defaultMilestoneEmit(name, data) {
    try {
      if (typeof window.clarity === "function") window.clarity("event", name);
    } catch (e) {
      /* Clarity absent or blocked */
    }
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === "function"
      ) {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) {
      /* pixel bus absent */
    }
  }

  function BirthDataForm(container) {
    this.container = container;
    this.instanceId = "astro-" + ++BirthDataForm._instanceCount;
    this.tier = (container.getAttribute("data-tier") || "full").toLowerCase();
    this.apiBase =
      container.getAttribute("data-api-base") ||
      window.location.origin + "/apps/astrology";
    this.geocoder = createGeocoder(this.apiBase);

    // Locale bundle (plan D3): catalog-fed config with per-key EN fallback.
    this.config = loadFormConfig();
    this.t = makeT(this.config);
    // The Essential-hint URL: config first, the mount attribute as the
    // independent fallback channel; with neither, the hint renders linkless
    // (narrowed fallback claim, Sol S5) — never a hardcoded handle here.
    this.essentialUrl =
      (typeof this.config.essentialUrl === "string" && this.config.essentialUrl) ||
      container.getAttribute("data-essential-url") ||
      "";
    // Localized DISPLAY property names (checkout renders these labels). The
    // canonical hidden keys are wire contract and stay literal at the
    // emission sites; each display/canonical pair is written from ONE
    // shared value so the values can never diverge (plan D1).
    this.propNames = {
      clientName: "properties[" + this.t("property_client_name") + "]",
      birthTime: "properties[" + this.t("property_birth_time") + "]",
      birthPlace: "properties[" + this.t("property_birth_place") + "]",
    };

    // State
    this.selectedPlace = null;
    this.map = null;
    this.marker = null;
    this.birthDateHelpers = createBirthDateHelpers(undefined, {
      t: this.t,
      dateLabel: this.t("property_birth_date"),
    });
    // Per-locale time-input mode (REC-1): top-level config metadata, NOT a
    // strings/EN_DEFAULT entry (it is a behavior token, not copy). Exact
    // "24h" or the 12-h default.
    this.timeFormat = this.config.timeFormat === "24h" ? "24h" : "12h";
    this.birthTimeHelpers = createBirthTimeHelpers(this.timeFormat);
    this.dateInteracted = false;
    this.submitAttempted = false;
    this.milestones = createMilestoneTracker(defaultMilestoneEmit);

    // DOM references (populated by render())
    this.nameInput = null;
    this.monthInput = null;
    this.dayInput = null;
    this.yearInput = null;
    this.dateError = null;
    this.nativeProductForm = null;
    this.timeInput = null;
    this.timeGroup = null;
    this.placeInput = null;
    this.dropdown = null;
    this.mapContainer = null;
    this.coordsDisplay = null;
    this.submitBtn = null;
    this.hiddenFields = {};

    // Derived flags
    this.isEssential = this.tier === "essential";

    // Dropdown keyboard navigation state
    this._dropdownResults = [];
    this._highlightIndex = -1;
    // Enter pressed before suggestions arrived (select top match on arrival)
    this._pendingEnter = null;
    // Last non-empty result list (survives dropdown close, for auto-accept)
    // plus the cleaned query it was fetched for (staleness guard)
    this._lastResults = [];
    this._lastResultsQuery = "";
    // Reverse-geocode request sequencing (stale responses are ignored)
    this._reverseSeq = 0;

    // Document click listener reference (for cleanup)
    this._onDocumentClick = null;

    // Build
    this.render();
    this.bindEvents();

    // Performance: the map (Leaflet CSS + JS + OpenStreetMap tiles, ~400 KB)
    // is now fully on-demand. It starts collapsed behind the "Fine-tune on
    // the map" toggle and nothing map-related is fetched until the customer
    // opens it. The autocomplete alone covers the normal path; the map stays
    // available for pin-drop fine-tuning and cities the geocoder can't find.
  }

  // One name per pageload; the payload is tier-only by design (no PII).
  BirthDataForm.prototype._trackMilestone = function (name) {
    if (!this.milestones) return;
    this.milestones.hit(name, {
      tier: this.isEssential ? "essential" : "full",
    });
  };

  // ─── render() — builds the entire form DOM ────────────────────────
  BirthDataForm.prototype.render = function () {
    this.container.innerHTML = "";
    this.container.classList.add("astro-widget");

    var form = createElement("div", { className: "astro-form" });

    // ── Name ─────────────────────────────────────────────────────────
    // The live inputs carry INTERNAL names only (_astro_*, same
    // Shopify-ignored class as _birth_month): the line-item properties are
    // written exclusively by the submit paths, so each property name is
    // emitted exactly once per POST (single-writer rule, plan D1/Sol S4).
    var nameId = this.instanceId + "-name";
    var nameGroup = createElement("div", { className: "astro-field" }, [
      createElement("label", { for: nameId, textContent: this.t("label_name") }),
      createElement("input", {
        type: "text",
        id: nameId,
        name: "_astro_client_name",
        placeholder: this.t("placeholder_name"),
        required: "required",
        autocomplete: "name",
        "aria-describedby": nameId + "-error",
      }),
      createElement("p", {
        id: nameId + "-error",
        className: "astro-field-error astro-hidden",
        role: "alert",
      }),
    ]);
    this.nameInput = nameGroup.querySelector("input");
    this.nameError = nameGroup.querySelector(".astro-field-error");
    this.nameGroup = nameGroup;
    form.appendChild(nameGroup);

    // ── Birth Date ───────────────────────────────────────────────────
    var dateId = this.instanceId + "-birth-date";
    var dateErrorId = dateId + "-error";
    var self = this;
    var monthSelect = createElement("select", {
      id: dateId + "-month",
      name: "_birth_month",
      required: "required",
      autocomplete: "bday-month",
      "aria-describedby": dateErrorId,
    });
    monthSelect.appendChild(createElement("option", {
      value: "",
      textContent: this.t("option_month"),
      disabled: "disabled",
      selected: "selected",
    }));
    MONTH_NAMES.forEach(function (monthName, index) {
      monthSelect.appendChild(createElement("option", {
        value: String(index + 1),
        textContent: self.t("month_" + (index + 1)),
      }));
    });
    var dateGroup = createElement("fieldset", { className: "astro-field astro-date-field" }, [
      createElement("legend", { textContent: this.t("legend_birth_date") }),
      createElement("div", { className: "astro-date-row" }, [
        createElement("div", { className: "astro-date-part astro-date-part--month" }, [
          createElement("label", { for: dateId + "-month", textContent: this.t("label_month") }),
          monthSelect,
        ]),
        createElement("div", { className: "astro-date-part" }, [
          createElement("label", { for: dateId + "-day", textContent: this.t("label_day") }),
          createElement("input", {
            type: "text",
            id: dateId + "-day",
            name: "_birth_day",
            placeholder: this.t("placeholder_day"),
            required: "required",
            autocomplete: "bday-day",
            inputmode: "numeric",
            pattern: "[0-9]*",
            maxlength: "2",
            "aria-describedby": dateErrorId,
          }),
        ]),
        createElement("div", { className: "astro-date-part" }, [
          createElement("label", { for: dateId + "-year", textContent: this.t("label_year") }),
          createElement("input", {
            type: "text",
            id: dateId + "-year",
            name: "_birth_year",
            placeholder: this.t("placeholder_year"),
            required: "required",
            autocomplete: "bday-year",
            inputmode: "numeric",
            pattern: "[0-9]*",
            maxlength: "4",
            "aria-describedby": dateErrorId,
          }),
        ]),
      ]),
      createElement("p", {
        id: dateErrorId,
        className: "astro-field-error astro-date-error astro-hidden",
        role: "alert",
      }),
    ]);
    this.monthInput = monthSelect;
    this.dayInput = dateGroup.querySelector("#" + dateId + "-day");
    this.yearInput = dateGroup.querySelector("#" + dateId + "-year");
    this.dateError = dateGroup.querySelector("#" + dateErrorId);
    this.dateGroup = dateGroup;
    form.appendChild(dateGroup);

    // ── Birth Time (hidden for Essential tier) — 12h + AM/PM, or a native
    // 24h hour+minute pair per the locale's time_format token (REC-1) ──
    var timeId = this.instanceId + "-time";
    var is24h = this.birthTimeHelpers.is24h;
    var hourSelect = createElement("select", {
      id: timeId + "-hour",
      name: "_birth_hour",
      "aria-label": this.t("aria_birth_hour")
    });
    hourSelect.appendChild(createElement("option", { value: "", textContent: this.t("option_hr"), disabled: "disabled", selected: "selected" }));
    if (is24h) {
      for (var h24opt = 0; h24opt <= 23; h24opt++) {
        hourSelect.appendChild(createElement("option", { value: String(h24opt), textContent: pad2(h24opt) }));
      }
    } else {
      for (var h = 1; h <= 12; h++) {
        hourSelect.appendChild(createElement("option", { value: String(h), textContent: String(h) }));
      }
    }

    var minuteSelect = createElement("select", {
      id: timeId + "-minute",
      name: "_birth_minute",
      "aria-label": this.t("aria_birth_minute")
    });
    minuteSelect.appendChild(createElement("option", { value: "", textContent: this.t("option_min"), disabled: "disabled", selected: "selected" }));
    for (var mi = 0; mi < 60; mi++) {
      minuteSelect.appendChild(createElement("option", { value: String(mi).padStart(2,"0"), textContent: String(mi).padStart(2,"0") }));
    }

    // The AM/PM select exists only in 12-h mode; option VALUES "AM"/"PM"
    // are logic tokens — only the visible textContent localizes.
    var ampmSelect = null;
    if (!is24h) {
      ampmSelect = createElement("select", {
        id: timeId + "-ampm",
        name: "_birth_ampm",
        "aria-label": this.t("aria_am_pm")
      });
      ampmSelect.appendChild(createElement("option", { value: "", textContent: this.t("option_ampm"), disabled: "disabled", selected: "selected" }));
      ampmSelect.appendChild(createElement("option", { value: "AM", textContent: this.t("option_am") }));
      ampmSelect.appendChild(createElement("option", { value: "PM", textContent: this.t("option_pm") }));
    }

    var timeHidden = createElement("input", {
      type: "hidden",
      id: timeId,
      name: "_astro_birth_time"
    });

    var birthTimeHelpers = this.birthTimeHelpers;
    function syncTime() {
      timeHidden.value = birthTimeHelpers.buildValue(
        hourSelect.value,
        minuteSelect.value,
        ampmSelect ? ampmSelect.value : ""
      );
      if (typeof self.validate === "function") self.validate();
    }
    hourSelect.addEventListener("change", syncTime);
    minuteSelect.addEventListener("change", syncTime);
    if (ampmSelect) ampmSelect.addEventListener("change", syncTime);

    if (!this.isEssential) {
      timeHidden.required = "required";
    }

    // The time hint is the ONE localized innerHTML sink (markup-bearing
    // `_html` catalog value; audited — plan D3/Sol S5). The URL arrives
    // pre-substituted in the config string; the EN default carries an
    // [essential_url] token filled from the fallback channel, and with no
    // URL at all the hint degrades to link-free text.
    var hintHtml = this.t("time_hint_html");
    var hintP = createElement("p", { className: "astro-hint" });
    if (hintHtml.indexOf("[essential_url]") === -1) {
      hintP.innerHTML = hintHtml;
    } else if (this.essentialUrl) {
      hintP.innerHTML = fillTemplate(hintHtml, { essential_url: this.essentialUrl });
    } else {
      hintP.textContent = hintHtml
        .replace(/<a [^>]*>/g, "")
        .replace(/<\/a>/g, "")
        .split("[essential_url]").join("");
    }
    var timeParts = [
      createElement("div", { className: "astro-date-part astro-time-part" }, [
        createElement("label", { for: timeId + "-hour", textContent: this.t("label_hour") }),
        hourSelect,
      ]),
      createElement("div", { className: "astro-date-part astro-time-part" }, [
        createElement("label", { for: timeId + "-minute", textContent: this.t("label_minute") }),
        minuteSelect,
      ]),
    ];
    if (!is24h) {
      timeParts.push(
        createElement("div", { className: "astro-date-part astro-time-part" }, [
          createElement("label", { for: timeId + "-ampm", textContent: this.t("label_ampm") }),
          ampmSelect,
        ])
      );
    }
    this.timeGroup = createElement(
      "div",
      { className: "astro-field" + (this.isEssential ? " astro-hidden" : "") },
      [
        createElement("label", { for: timeId + "-hour", textContent: this.t("label_birth_time") }),
        createElement("div", { className: "astro-time-row" + (is24h ? " astro-time-row--24h" : "") }, timeParts),
        timeHidden,
        createElement("p", {
          className: "astro-field-error astro-hidden",
          role: "alert",
        }),
        hintP,
      ]
    );
    this.timeError = this.timeGroup.querySelector(".astro-field-error");
    this.timeInput = timeHidden;
    form.appendChild(this.timeGroup);

    // ── Birth Place with autocomplete ────────────────────────────────
    var placeId = this.instanceId + "-place";
    var placeGroup = createElement(
      "div",
      { className: "astro-field astro-place-group" },
      [
        createElement("label", {
          for: placeId,
          textContent: this.t("label_birth_place"),
        }),
        createElement("div", { className: "astro-autocomplete-wrapper" }, [
          createElement("input", {
            type: "text",
            id: placeId,
            placeholder: this.t("placeholder_birth_place"),
            autocomplete: "off",
            required: "required",
            role: 'combobox',
            'aria-autocomplete': 'list',
            'aria-expanded': 'false',
            'aria-haspopup': 'listbox',
          }),
          createElement("ul", {
            className: "astro-dropdown astro-hidden",
            role: 'listbox',
            'aria-label': this.t("aria_place_results"),
          }),
        ]),
        createElement("p", {
          className: "astro-field-error astro-hidden",
          role: "alert",
        }),
      ]
    );
    this.placeInput = placeGroup.querySelector("input");
    this.dropdown = placeGroup.querySelector(".astro-dropdown");
    this.placeError = placeGroup.querySelector(".astro-field-error");
    this.placeGroup = placeGroup;
    form.appendChild(placeGroup);

    // ── Map (collapsed until requested; Leaflet loads on first open) ──
    var mapId = this.instanceId + "-map";
    this._mapOpen = false;
    this.mapToggle = createElement("button", {
      type: "button",
      className: "astro-map-toggle",
      "aria-expanded": "false",
      "aria-controls": mapId,
      textContent: this.t("map_open_html"),
    });
    form.appendChild(this.mapToggle);
    this.mapContainer = createElement(
      "div",
      { className: "astro-map-container astro-map-collapsed" },
      [
        createElement("div", { id: mapId, className: "astro-map" }),
        createElement("p", {
          className: "astro-hint astro-coords",
          textContent: this.t("map_coords_hint"),
        }),
      ]
    );
    this.coordsDisplay = this.mapContainer.querySelector(".astro-coords");
    form.appendChild(this.mapContainer);

    // ── Hidden fields for Shopify line item properties ────────────────
    var hiddenContainer = createElement("div", {
      className: "astro-hidden-fields",
    });
    var hiddenDefs = [
      { name: "_astro_birth_place", key: "birthPlace" },
      { name: "_astro_latitude", key: "latitude" },
      { name: "_astro_longitude", key: "longitude" },
      { name: "_astro_timezone", key: "timezone" },
    ];
    var self = this;
    hiddenDefs.forEach(function (def) {
      var input = createElement("input", {
        type: "hidden",
        name: def.name,
      });
      self.hiddenFields[def.key] = input;
      hiddenContainer.appendChild(input);
    });
    form.appendChild(hiddenContainer);

    // ── Add to Cart button ───────────────────────────────────────────
    var ctaLabel = this.t("cta_chart");
    if (this.tier === 'essential') ctaLabel = this.t("cta_essential");
    else if (this.tier === 'full') ctaLabel = this.t("cta_full");
    this.defaultCtaLabel = ctaLabel;

    // The button stays CLICKABLE while incomplete (astro-submit--blocked +
    // aria-disabled instead of a disabled attribute): clicking it walks the
    // customer to exactly what's missing instead of doing nothing.
    this.submitBtn = createElement("button", {
      type: "submit",
      className: "astro-submit astro-submit--blocked",
      "aria-disabled": "true",
      textContent: ctaLabel,
    });
    form.appendChild(this.submitBtn);

    // ── Helper hint (shown while disabled) + reassurance microcopy ──
    this.submitHint = createElement("p", {
      className: "astro-submit-hint",
      textContent: this.t("submit_hint"),
    });
    form.appendChild(this.submitHint);

    var reassurance = createElement("p", {
      className: "astro-reassurance",
    });
    // Build with inline SVGs for a crisp luxury feel (no emoji).
    // Privacy ("Birth data deleted automatically") renders ABOVE the fields in
    // the form header (astro-birth-data-form.liquid), so each trust signal
    // appears exactly once in the column: privacy before the data entry,
    // delivery + refund at the commit point here. The SVG markup is STATIC
    // trusted strings; the localized labels enter as text nodes only
    // (plan D3/Sol S5 — no catalog value reaches innerHTML here).
    var reassuranceItem = function (svgMarkup, text) {
      var item = createElement("span", { className: "astro-reassurance__item" });
      item.innerHTML = svgMarkup;
      item.appendChild(document.createTextNode(text));
      return item;
    };
    reassurance.appendChild(reassuranceItem(
      '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
      this.t("typically_1h")
    ));
    reassurance.appendChild(createElement("span", {
      className: "astro-reassurance__sep",
      "aria-hidden": "true",
      textContent: "·",
    }));
    reassurance.appendChild(reassuranceItem(
      '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
      this.t("refund_14")
    ));
    form.appendChild(reassurance);

    // Hide native buy buttons so customers must use our validated form
    this._hideNativeBuyButtons();

    this.container.appendChild(form);

    // ── Screen reader status region ────────────────────────────────
    this.statusRegion = createElement('div', {
      className: 'astro-sr-only',
      'aria-live': 'polite',
      'aria-atomic': 'true',
      role: 'status'
    });
    this.container.appendChild(this.statusRegion);
  };

  // ─── bindEvents() ─────────────────────────────────────────────────
  BirthDataForm.prototype.bindEvents = function () {
    var self = this;

    // "Form started" = first interaction anywhere in the widget
    // (pointerdown covers browsers where buttons don't take focus).
    var markStarted = function () {
      self._trackMilestone("wd_form_start");
    };
    this.container.addEventListener("focusin", markStarted);
    this.container.addEventListener("pointerdown", markStarted);

    // Validation on every keystroke / change
    var dateInputs = [this.monthInput, this.dayInput, this.yearInput];
    var validateInputs = [this.nameInput, this.placeInput].concat(dateInputs);
    if (!this.isEssential) validateInputs.push(this.timeInput);
    validateInputs.forEach(function (input) {
      input.addEventListener("input", function () {
        self.validate();
      });
      input.addEventListener("change", function () {
        self.validate();
      });
    });

    // The date error may only appear once the customer is DONE with the
    // date group: focus left the fieldset with a partial date behind.
    // Flagging on keystroke punished people mid-entry ("required" while
    // still typing). activeElement is checked after a tick because
    // focusout fires before the next field receives focus.
    this.dateGroup.addEventListener("focusout", function () {
      setTimeout(function () {
        if (self.dateGroup.contains(document.activeElement)) return;
        var touched =
          (self.monthInput && self.monthInput.value) ||
          (self.dayInput && self.dayInput.value.trim()) ||
          (self.yearInput && self.yearInput.value.trim());
        if (touched) {
          self.dateInteracted = true;
          self.validate();
        }
      }, 0);
    });

    // Clear stale place selection when user edits the text
    this.placeInput.addEventListener("input", function () {
      if (self.selectedPlace) {
        var expected = [self.selectedPlace.name];
        if (self.selectedPlace.admin1) expected.push(self.selectedPlace.admin1);
        if (self.selectedPlace.country) expected.push(self.selectedPlace.country);
        if (self.placeInput.value !== expected.join(", ")) {
          self.selectedPlace = null;
          self.hiddenFields.birthPlace.value = "";
          self.hiddenFields.latitude.value = "";
          self.hiddenFields.longitude.value = "";
          self.hiddenFields.timezone.value = "";
          self.validate();
        }
      }
    });

    // Debounced geocoder search
    var debouncedSearch = debounce(function () {
      self.onPlaceInput();
    }, DEBOUNCE_MS);
    this.placeInput.addEventListener("input", debouncedSearch);

    // Any edit invalidates a queued Enter-intent
    this.placeInput.addEventListener("input", function () {
      self._pendingEnter = null;
    });

    // Re-open suggestions when refocusing a filled, not-yet-picked field
    this.placeInput.addEventListener("focus", function () {
      if (
        !self.selectedPlace &&
        cleanPlaceQuery(self.placeInput.value).length >= MIN_QUERY_LENGTH &&
        self.dropdown.classList.contains("astro-hidden")
      ) {
        self.onPlaceInput();
      }
    });

    // If the customer typed the city in full but never clicked a
    // suggestion, accept the exact match on blur instead of blocking
    // at the button. (A click on a suggestion still wins: it fires
    // after blur and simply selects again.)
    this.placeInput.addEventListener("blur", function () {
      self._tryAutoAcceptExact();
    });

    // Close dropdown on outside click (store reference for cleanup)
    this._onDocumentClick = function (e) {
      if (!self.container.contains(e.target)) self.hideDropdown();
    };
    document.addEventListener("click", this._onDocumentClick);

    // Clicking inside the dropdown must not blur the input first:
    // blur would run exact auto-accept, which hides the dropdown and
    // detaches the clicked row before its click event can fire —
    // silently overriding the customer's explicit choice.
    this.dropdown.addEventListener("mousedown", function (e) {
      e.preventDefault();
    });

    // Keyboard navigation in dropdown
    this.placeInput.addEventListener("keydown", function (e) {
      self.onPlaceKeydown(e);
    });

    // Map toggle (collapsed by default; Leaflet loads on first open)
    this.mapToggle.addEventListener("click", function () {
      self.toggleMap();
    });

    // Submit — own button
    this.submitBtn.addEventListener("click", function (e) {
      e.preventDefault();
      self.onSubmit();
    });

    this.nativeProductForm = this._findNativeProductForm();
    this._bindNativeProductFormSubmit(this.nativeProductForm);
  };

  BirthDataForm.prototype._findNativeProductForm = function () {
    var formSelector = 'form[action*="/cart/add"][data-type="add-to-cart-form"], form[action*="/cart/add"]';
    var closestForm = this.container.closest && this.container.closest('form[action*="/cart/add"]');
    if (closestForm) return closestForm;

    var doc = this.container.ownerDocument || document;
    var section = this.container.closest && this.container.closest('[id^="shopify-section-"], .shopify-section, section, main');
    if (section && typeof section.querySelector === "function") {
      var sectionForm = section.querySelector(formSelector);
      if (sectionForm) return sectionForm;
    }

    if (doc && typeof doc.querySelector === "function") {
      return doc.querySelector(formSelector);
    }
    return null;
  };

  BirthDataForm.prototype._bindNativeProductFormSubmit = function (productForm) {
    if (!productForm || productForm._astroBirthSubmitBound) return;
    var self = this;
    productForm._astroBirthSubmitBound = true;
    productForm.addEventListener("submit", function (e) {
      if (!self.prepareNativeProductFormSubmit(productForm)) {
        if (e && typeof e.preventDefault === "function") e.preventDefault();
        if (e && typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
      }
    }, { capture: true });
  };

  BirthDataForm.prototype.prepareNativeProductFormSubmit = function (productForm) {
    if (this.nativeProductForm && productForm !== this.nativeProductForm) return true;
    this.submitAttempted = true;
    this._tryAutoAcceptExact();
    if (!productForm || !this.validate()) {
      // Only after the widget has rendered (submitBtn exists); the native
      // bridge can fire on partially constructed instances in tests.
      if (this.submitBtn) this._showBlockedFeedback();
      return false;
    }
    this._trackMilestone("wd_form_completed");
    this._injectHiddenInputs(productForm);
    return true;
  };

  // ─── Hide native buy buttons on astrology product pages ──────────
  BirthDataForm.prototype._hideNativeBuyButtons = function () {
    // Hide native buy buttons and quantity selector
    var selectors = [
      "buy-buttons",
      ".buy-buttons",
      "[data-block-type='buy-buttons']",
      ".product-form__submit",
      ".shopify-payment-button",
      "sticky-add-to-cart",
      ".sticky-add-to-cart",
      ".add-to-cart-button",
      "accelerated-checkout",
      ".quantity-selector-wrapper",
      "quantity-selector-component",
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.display = "none";
      });
    });
  };

  // ─── Place autocomplete ────────────────────────────────────────────
  BirthDataForm.prototype.onPlaceInput = function () {
    var query = cleanPlaceQuery(this.placeInput.value);
    if (query.length < MIN_QUERY_LENGTH) {
      this.hideDropdown();
      return;
    }
    // A selection whose display text still fills the input needs no
    // search: this stops the trailing debounce timer from reopening the
    // dropdown right after an Enter-selection.
    if (
      this.selectedPlace &&
      this.placeInput.value === placeDisplayString(this.selectedPlace)
    ) {
      this.hideDropdown();
      return;
    }
    var self = this;
    var wrapper = this.placeInput.parentElement;
    wrapper.classList.add('astro-loading');
    // One silent retry (covers a hiccup or a 429 from the rate limiter),
    // then a visible message: a silent dead end here was the worst failure
    // mode in the whole form.
    var attempt = function (isRetry) {
      self.geocoder(query, function (err, results) {
        if (err) {
          if (!isRetry) {
            setTimeout(function () {
              if (cleanPlaceQuery(self.placeInput.value) === query) {
                attempt(true);
              } else {
                wrapper.classList.remove("astro-loading");
              }
            }, 1200);
            return;
          }
          wrapper.classList.remove("astro-loading");
          self._trackMilestone("wd_form_place_lookup_failed");
          self.showDropdownMessage(self.t("geo_error"));
          return;
        }
        wrapper.classList.remove("astro-loading");
        self.showDropdown(results);
      });
    };
    attempt(false);
  };

  // Show a single informational row in the dropdown (errors, guidance).
  // Message rows use astro-dropdown-message (NOT astro-dropdown-item) so
  // they never participate in keyboard navigation or aria-activedescendant.
  BirthDataForm.prototype.showDropdownMessage = function (text) {
    this.dropdown.innerHTML = "";
    var item = createElement("li", {
      className: "astro-dropdown-message astro-no-results",
      textContent: text,
      "aria-disabled": "true",
    });
    this.dropdown.appendChild(item);
    this.dropdown.classList.remove("astro-hidden");
    this.placeInput.setAttribute("aria-expanded", "true");
    this._dropdownResults = [];
    this._highlightIndex = -1;
    if (this.statusRegion) this.statusRegion.textContent = text;
  };

  // Bold the typed text inside a suggestion's name (text nodes only).
  BirthDataForm.prototype._buildPlaceName = function (labelText, typed) {
    var span = createElement("span", { className: "astro-place-name" });
    var label = String(labelText || "");
    var needle = (typed || "").toLowerCase();
    var idx = needle ? label.toLowerCase().indexOf(needle) : -1;
    if (idx === -1) {
      span.textContent = label;
      return span;
    }
    if (idx > 0) span.appendChild(document.createTextNode(label.slice(0, idx)));
    span.appendChild(
      createElement("strong", { textContent: label.slice(idx, idx + needle.length) })
    );
    if (idx + needle.length < label.length) {
      span.appendChild(document.createTextNode(label.slice(idx + needle.length)));
    }
    return span;
  };

  BirthDataForm.prototype.showDropdown = function (results) {
    this.dropdown.innerHTML = "";
    if (!results || results.length === 0) {
      this._trackMilestone("wd_form_place_no_matches");
      var noResult = createElement('li', {
        className: 'astro-dropdown-message astro-no-results',
        textContent: this.t("geo_no_matches"),
        'aria-disabled': 'true'
      });
      this.dropdown.appendChild(noResult);
      this.dropdown.classList.remove('astro-hidden');
      this.placeInput.setAttribute('aria-expanded', 'true');
      this._dropdownResults = [];
      this._highlightIndex = -1;
      this.statusRegion.textContent = this.t("geo_no_matches_sr");
      return;
    }
    var self = this;
    var typed = cleanPlaceQuery(this.placeInput.value);
    var dividerAdded = false;
    results.forEach(function (place, index) {
      // Typo corrections sit behind a "Closest matches" divider (not an
      // option itself, so it never participates in keyboard navigation).
      if (place.match === "fuzzy" && !dividerAdded) {
        dividerAdded = true;
        self.dropdown.appendChild(createElement("li", {
          className: "astro-dropdown-divider",
          textContent: self.t("geo_closest"),
          "aria-hidden": "true",
        }));
      }
      var itemId = self.instanceId + '-option-' + index;
      var li = createElement("li", {
        className: "astro-dropdown-item",
        id: itemId,
        "data-index": String(index),
        role: "option",
      });
      li.appendChild(self._buildPlaceName(place.display_name || place.name, typed));
      if (!place.display_name && (place.admin1 || place.country)) {
        var detailParts = [];
        if (place.admin1) detailParts.push(place.admin1);
        if (place.country) detailParts.push(place.country);
        li.appendChild(
          createElement("span", {
            className: "astro-place-detail",
            textContent: detailParts.join(", "),
          })
        );
      }
      li.addEventListener("click", function () {
        self.selectPlace(place);
      });
      li.addEventListener("mouseenter", function () {
        self._highlightIndex = index;
        self._updateHighlight(
          self.dropdown.querySelectorAll(".astro-dropdown-item")
        );
      });
      self.dropdown.appendChild(li);
    });
    this.dropdown.classList.remove("astro-hidden");
    this.placeInput.setAttribute('aria-expanded', 'true');
    this._dropdownResults = results;
    this._lastResults = results;
    this._lastResultsQuery = typed.toLowerCase();

    // Enter pressed while these results were loading: select the top match.
    if (this._pendingEnter && this._pendingEnter === typed) {
      this._pendingEnter = null;
      this.selectPlace(results[0]);
      return;
    }
    this._pendingEnter = null;

    // Default-highlight the top suggestion so Enter selects it immediately.
    this._highlightIndex = 0;
    this._updateHighlight(this.dropdown.querySelectorAll(".astro-dropdown-item"));
    var topLabel = placeDisplayString(results[0]);
    this.statusRegion.textContent = fillTemplate(this.t("sr_results"), {
      count: results.length,
      place: topLabel,
    });
  };

  BirthDataForm.prototype.hideDropdown = function () {
    this.dropdown.classList.add("astro-hidden");
    this.dropdown.innerHTML = "";
    this.placeInput.setAttribute('aria-expanded', 'false');
    this.placeInput.removeAttribute('aria-activedescendant');
    this._dropdownResults = [];
    this._highlightIndex = -1;
  };

  BirthDataForm.prototype.onPlaceKeydown = function (e) {
    var items = this.dropdown.querySelectorAll(".astro-dropdown-item");

    if (e.key === "Enter") {
      // Enter in the place field must never submit the form mid-typing.
      e.preventDefault();
      if (
        items.length &&
        this._highlightIndex >= 0 &&
        this._dropdownResults &&
        this._dropdownResults[this._highlightIndex]
      ) {
        this.selectPlace(this._dropdownResults[this._highlightIndex]);
      } else if (!this.selectedPlace) {
        // Suggestions not in yet: remember the intent, search right away,
        // and select the top match when the list arrives.
        this._pendingEnter = cleanPlaceQuery(this.placeInput.value);
        this.onPlaceInput();
      }
      return;
    }

    if (!items.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      this._highlightIndex = Math.min(
        this._highlightIndex + 1,
        items.length - 1
      );
      this._updateHighlight(items);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      this._highlightIndex = Math.max(this._highlightIndex - 1, 0);
      this._updateHighlight(items);
    } else if (e.key === "Escape") {
      this.hideDropdown();
    }
  };

  BirthDataForm.prototype._updateHighlight = function (items) {
    var idx = this._highlightIndex;
    items.forEach(function (item, i) {
      item.classList.toggle("astro-dropdown-highlight", i === idx);
    });
    if (items[idx]) {
      try { items[idx].scrollIntoView({ block: 'nearest' }); }
      catch(e) { items[idx].scrollIntoView(false); }
      this.placeInput.setAttribute('aria-activedescendant', items[idx].id);
    } else {
      this.placeInput.removeAttribute('aria-activedescendant');
    }
  };

  // Accept the suggestion whose text the customer already typed in full
  // (exact display string, or a uniquely-named exact match). Runs on blur
  // and at both submit entry points — never on keystrokes, so it cannot
  // rewrite the input mid-typing. The unique-name shortcut only applies
  // when the cached results were fetched for exactly the current text;
  // "unique in a stale result set" is not unique. The full display-string
  // match stays allowed on stale results — it pins region and country, so
  // it is unambiguous regardless of which query produced the row.
  BirthDataForm.prototype._tryAutoAcceptExact = function () {
    if (this.selectedPlace || !this.placeInput) return false;
    var results =
      this._dropdownResults && this._dropdownResults.length
        ? this._dropdownResults
        : this._lastResults;
    if (!results || !results.length) return false;
    var typed = cleanPlaceQuery(this.placeInput.value);
    var fresh = this._lastResultsQuery === typed.toLowerCase();
    var match = findExactPlaceMatch(results, typed, { nameMatchAllowed: fresh });
    if (match) {
      this.selectPlace(match);
      return true;
    }
    return false;
  };

  // ─── Place selection ───────────────────────────────────────────────
  BirthDataForm.prototype.selectPlace = function (place) {
    this.selectedPlace = place;

    // Use display_name from geocoder if available, otherwise build it
    var displayName = place.display_name;
    if (!displayName) {
      var displayParts = [place.name];
      if (place.admin1) displayParts.push(place.admin1);
      if (place.country) displayParts.push(place.country);
      displayName = displayParts.join(", ");
    }

    this.placeInput.value = displayName;
    this.hideDropdown();

    // Populate hidden fields
    this.hiddenFields.birthPlace.value = displayName;
    this.hiddenFields.latitude.value = place.latitude;
    this.hiddenFields.longitude.value = place.longitude;
    this.hiddenFields.timezone.value = place.timezone;

    // Re-centre the map only if the customer opened it; otherwise the
    // resolved place name in the input is the confirmation.
    if (this._mapOpen) {
      this.showMap(place.latitude, place.longitude);
    }
    this.validate();
  };

  // ─── Map toggle (collapsed by default) ────────────────────────────
  BirthDataForm.prototype.toggleMap = function () {
    var self = this;
    if (!this._mapOpen) {
      this._mapOpen = true;
      this.mapContainer.classList.remove("astro-map-collapsed");
      this.mapToggle.setAttribute("aria-expanded", "true");
      this.mapToggle.textContent = this.t("map_close");
      var p = this.selectedPlace;
      if (p && p.latitude != null && p.longitude != null) {
        this.showMap(p.latitude, p.longitude);
      } else {
        // Neutral wide view; clicking the map drops a pin and
        // reverse-geocodes it into the place field.
        this.showMap(30, 0, 2);
      }
      // A Leaflet map created or re-shown inside a previously hidden
      // container needs a size recalculation once it is visible.
      setTimeout(function () {
        if (self.map) self.map.invalidateSize();
      }, 150);
    } else {
      this._mapOpen = false;
      this.mapContainer.classList.add("astro-map-collapsed");
      this.mapToggle.setAttribute("aria-expanded", "false");
      this.mapToggle.textContent = this.t("map_open_html");
    }
  };

  // ─── Leaflet map ──────────────────────────────────────────────────
  BirthDataForm.prototype.showMap = function (lat, lng, zoom) {
    var self = this;
    var zoomLevel = zoom || MAP_ZOOM_DEFAULT;

    loadLeaflet(function () {
      var mapEl = self.mapContainer.querySelector(".astro-map");

      // If map already exists, just re-centre
      if (self.map) {
        self.map.setView([lat, lng], zoomLevel);
        if (zoomLevel > 3) {
          self._ensureMarker(lat, lng);
          self._updateCoordsDisplay(lat, lng);
        } else if (self.marker) {
          self.marker.setLatLng([lat, lng]);
        }
        return;
      }

      // First-time creation
      self.map = L.map(mapEl).setView([lat, lng], zoomLevel);
      L.tileLayer(TILE_URL, {
        attribution: TILE_ATTRIBUTION,
        maxZoom: 18,
      }).addTo(self.map);

      // On a neutral wide view (map opened with no place selected yet) no
      // pin is dropped; the marker appears on the first real location.
      if (zoomLevel > 3) {
        self._ensureMarker(lat, lng);
      }

      // Click map to move (or drop) the pin — reverse geocode updates the city
      self.map.on("click", function (e) {
        var snapshot = self._captureLocationState();
        self._ensureMarker(e.latlng.lat, e.latlng.lng);
        self._updateCoordinates(e.latlng.lat, e.latlng.lng);
        self._reverseGeocode(e.latlng.lat, e.latlng.lng, snapshot);
      });

      if (zoomLevel > 3) self._updateCoordsDisplay(lat, lng);

      // Fix Leaflet container-size issue
      setTimeout(function () {
        self.map.invalidateSize();
      }, 100);
    });
  };

  // Create the draggable marker on first need, or move it if it exists.
  BirthDataForm.prototype._ensureMarker = function (lat, lng) {
    var self = this;
    if (this.marker) {
      this.marker.setLatLng([lat, lng]);
      return;
    }
    this.marker = L.marker([lat, lng], { draggable: true }).addTo(this.map);
    // Drag pin to adjust — reverse geocode to update city name
    this.marker.on("dragend", function (e) {
      var snapshot = self._captureLocationState();
      var pos = e.target.getLatLng();
      self._updateCoordinates(pos.lat, pos.lng);
      self._reverseGeocode(pos.lat, pos.lng, snapshot);
    });
  };

  // Snapshot/restore of everything a pin move touches, so a failed
  // reverse lookup can roll back instead of leaving new coordinates
  // paired with a stale timezone or city name (a silently wrong chart).
  BirthDataForm.prototype._captureLocationState = function () {
    return {
      selectedPlace: this.selectedPlace,
      placeValue: this.placeInput ? this.placeInput.value : "",
      birthPlace: this.hiddenFields.birthPlace.value,
      latitude: this.hiddenFields.latitude.value,
      longitude: this.hiddenFields.longitude.value,
      timezone: this.hiddenFields.timezone.value,
    };
  };

  BirthDataForm.prototype._restoreLocationState = function (snapshot) {
    this.selectedPlace = snapshot.selectedPlace;
    if (this.placeInput) this.placeInput.value = snapshot.placeValue;
    this.hiddenFields.birthPlace.value = snapshot.birthPlace;
    this.hiddenFields.latitude.value = snapshot.latitude;
    this.hiddenFields.longitude.value = snapshot.longitude;
    this.hiddenFields.timezone.value = snapshot.timezone;
    if (this.marker && snapshot.latitude !== "" && snapshot.longitude !== "") {
      this.marker.setLatLng([
        Number(snapshot.latitude),
        Number(snapshot.longitude),
      ]);
      this._updateCoordsDisplay(
        Number(snapshot.latitude),
        Number(snapshot.longitude)
      );
    } else if (this.marker) {
      // There was no pin before this attempt: take the failed pin off the
      // map and reset the caption, so the UI matches the cleared fields.
      if (this.map) this.map.removeLayer(this.marker);
      this.marker = null;
      if (this.coordsDisplay) {
        this.coordsDisplay.textContent = this.t("map_coords_hint");
      }
    }
    this.validate();
  };

  BirthDataForm.prototype._reverseGeocode = function (lat, lng, snapshot) {
    var self = this;
    var seq = ++this._reverseSeq;
    var url = this.apiBase + "/reverse-geocode?lat=" + lat.toFixed(4) + "&lng=" + lng.toFixed(4);
    var revert = function () {
      // Only the newest pin move may change or restore state.
      if (seq !== self._reverseSeq) return;
      if (snapshot) self._restoreLocationState(snapshot);
      if (self.statusRegion) {
        self.statusRegion.textContent = self.t("sr_pin_reset");
      }
    };
    fetch(url)
      .then(function (resp) {
        if (!resp.ok) throw new Error("Reverse geocode error");
        return resp.json();
      })
      .then(function (place) {
        if (seq !== self._reverseSeq) return;
        if (place && place.name) {
          self.selectedPlace = place;
          var displayParts = [place.name];
          if (place.admin1) displayParts.push(place.admin1);
          if (place.country) displayParts.push(place.country);
          var displayName = displayParts.join(", ");
          self.placeInput.value = displayName;
          self.hiddenFields.birthPlace.value = displayName;
          self.hiddenFields.timezone.value = place.timezone;
          self.validate();
          if (self.statusRegion) {
            self.statusRegion.textContent = fillTemplate(self.t("sr_location_set"), { place: displayName });
          }
        } else {
          revert();
        }
      })
      .catch(revert);
  };

  BirthDataForm.prototype._updateCoordinates = function (lat, lng) {
    lat = Math.round(lat * 10000) / 10000;
    lng = Math.round(lng * 10000) / 10000;
    this.hiddenFields.latitude.value = lat;
    this.hiddenFields.longitude.value = lng;
    this._updateCoordsDisplay(lat, lng);
  };

  BirthDataForm.prototype._updateCoordsDisplay = function (lat, lng) {
    this.coordsDisplay.textContent = fillTemplate(this.t("map_coords"), {
      lat: Number(lat).toFixed(4),
      lng: Number(lng).toFixed(4),
    });
  };

  // ─── Validation ────────────────────────────────────────────────────
  BirthDataForm.prototype._birthDateParts = function () {
    return {
      month: this.monthInput ? this.monthInput.value : "",
      day: this.dayInput ? this.dayInput.value : "",
      year: this.yearInput ? this.yearInput.value : "",
    };
  };

  BirthDataForm.prototype._birthDateProperties = function () {
    return this.birthDateHelpers.buildBirthDateProperties(this._birthDateParts());
  };

  BirthDataForm.prototype._updateDateError = function (dateResult) {
    if (!this.dateError) return;
    var showError = !dateResult.ok && (this.dateInteracted || this.submitAttempted);
    this.dateError.textContent = showError ? dateResult.error : "";
    this.dateError.classList.toggle("astro-hidden", !showError);
    [this.monthInput, this.dayInput, this.yearInput].forEach(function (input) {
      if (!input) return;
      if (showError) input.setAttribute("aria-invalid", "true");
      else input.removeAttribute("aria-invalid");
    });
  };

  // One source of truth for what each field needs, used by validation,
  // per-field error display, and the blocked-click walkthrough.
  BirthDataForm.prototype._fieldStates = function () {
    var dateResult = this._birthDateProperties();
    var placeText = this.placeInput ? this.placeInput.value.trim() : "";
    return [
      {
        key: "name",
        ok: !!(this.nameInput && this.nameInput.value.trim()),
        label: this.t("missing_name"),
        message: this.t("error_name"),
        group: this.nameGroup,
        error: this.nameError,
        focus: this.nameInput,
      },
      {
        key: "date",
        ok: dateResult.ok,
        label: this.t("missing_date"),
        message: dateResult.error || this.t("error_date_fallback"),
        group: this.dateGroup,
        error: null,
        focus: this.monthInput,
      },
      {
        key: "time",
        ok: !!(this.isEssential || (this.timeInput && this.timeInput.value)),
        label: this.t("missing_time"),
        message: this.t("error_time"),
        group: this.isEssential ? null : this.timeGroup,
        error: this.isEssential ? null : this.timeError,
        focus: this.timeGroup ? this.timeGroup.querySelector("select") : null,
      },
      {
        key: "place",
        ok: !!this.selectedPlace,
        label: this.t("missing_place"),
        message: placeText
          ? this.t("error_place_pick")
          : this.t("error_place_add"),
        group: this.placeGroup,
        error: this.placeError,
        focus: this.placeInput,
      },
    ];
  };

  BirthDataForm.prototype._refreshFieldErrors = function () {
    var self = this;
    this._fieldStates().forEach(function (s) {
      var show = !s.ok && self.submitAttempted;
      if (s.key === "date") {
        // Error TEXT is handled by _updateDateError; the red border
        // treatment applies here so the date matches the other fields
        // (operator flagged the asymmetry).
        if (s.group) s.group.classList.toggle("astro-field--error", show);
        return;
      }
      if (s.error) {
        s.error.textContent = show ? s.message : "";
        s.error.classList.toggle("astro-hidden", !show);
      }
      if (s.group) s.group.classList.toggle("astro-field--error", show);
      if (s.focus && s.focus.setAttribute) {
        if (show) s.focus.setAttribute("aria-invalid", "true");
        else s.focus.removeAttribute("aria-invalid");
      }
    });
  };

  BirthDataForm.prototype._missingSummary = function () {
    var labels = this._fieldStates()
      .filter(function (s) { return !s.ok; })
      .map(function (s) { return s.label; });
    if (!labels.length) return "";
    if (labels.length === 1) {
      return fillTemplate(this.t("still_needed_one"), { item: labels[0] });
    }
    return fillTemplate(this.t("still_needed_many"), {
      items: labels.slice(0, -1).join(this.t("list_separator")),
      last: labels[labels.length - 1],
    });
  };

  BirthDataForm.prototype.validate = function () {
    var valid = true;
    var dateResult = this._birthDateProperties();
    if (!this.nameInput.value.trim()) valid = false;
    if (!dateResult.ok) valid = false;
    if (!this.isEssential && !this.timeInput.value) valid = false;
    if (!this.selectedPlace) valid = false;
    this._updateDateError(dateResult);

    this.submitBtn.classList.toggle("astro-submit--blocked", !valid);
    if (valid) {
      this.submitBtn.removeAttribute("aria-disabled");
      if (this.submitHint) {
        this.submitHint.classList.add("astro-hidden");
        this.submitHint.classList.remove("astro-submit-hint--alert");
        this.submitHint.textContent = this.t("submit_hint");
      }
    } else {
      this.submitBtn.setAttribute("aria-disabled", "true");
      if (this.submitHint) {
        this.submitHint.classList.remove("astro-hidden");
        // After a blocked click the hint becomes a live checklist that
        // updates as each missing piece is filled in.
        if (this.submitAttempted) {
          this.submitHint.textContent = this._missingSummary();
        }
      }
    }
    if (this.submitAttempted) this._refreshFieldErrors();

    // Funnel beacons: which fields have ever been completed this pageload.
    if (this.nameInput.value.trim()) this._trackMilestone("wd_form_name_filled");
    if (dateResult.ok) this._trackMilestone("wd_form_date_filled");
    if (!this.isEssential && this.timeInput.value) {
      this._trackMilestone("wd_form_time_filled");
    }
    if (this.selectedPlace) this._trackMilestone("wd_form_place_filled");

    return valid;
  };

  // Called when the customer clicks the CTA while something is missing:
  // per-field messages, a summary under the button, a screen-reader
  // announcement, and focus moved to the first missing field.
  BirthDataForm.prototype._showBlockedFeedback = function () {
    this._refreshFieldErrors();
    var missing = this._fieldStates().filter(function (s) { return !s.ok; });
    if (!missing.length) return;
    this._trackMilestone("wd_form_blocked_click");
    var summary = this._missingSummary();
    if (this.submitHint) {
      this.submitHint.textContent = summary;
      this.submitHint.classList.remove("astro-hidden");
      this.submitHint.classList.add("astro-submit-hint--alert");
    }
    if (this.statusRegion) this.statusRegion.textContent = summary;
    var first = missing[0];
    var target = first.group || this.container;
    // Focus BEFORE scrolling: focus is what opens the phone keyboard, and
    // the scroll must aim at the viewport that remains once it is up.
    if (first.focus && typeof first.focus.focus === "function") {
      try {
        first.focus.focus({ preventScroll: true });
      } catch (e2) {
        try { first.focus.focus(); } catch (e3) { /* focus is best-effort */ }
      }
    }
    this._scrollBlockedFieldIntoView(target);
  };

  // Scroll the first missing field into the middle of the area the
  // customer can actually see, waiting for the keyboard to settle so the
  // visual-viewport numbers are final.
  BirthDataForm.prototype._scrollBlockedFieldIntoView = function (target) {
    scheduleAfterKeyboardSettles(window, function () {
      var top = null;
      try {
        var vv = window.visualViewport;
        var rect = target.getBoundingClientRect();
        top = computeCenteredScrollTop({
          pageYOffset: window.pageYOffset || 0,
          rectTop: rect.top,
          rectHeight: rect.height,
          viewHeight: vv && vv.height ? vv.height : window.innerHeight,
          viewTop: (vv && vv.offsetTop) || 0,
        });
      } catch (e) {
        top = null;
      }
      if (top === null || !isFinite(top)) {
        try {
          target.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch (e2) {
          try { target.scrollIntoView(); } catch (e3) { /* best-effort */ }
        }
        return;
      }
      if ("scrollBehavior" in document.documentElement.style) {
        window.scrollTo({ top: top, behavior: "smooth" });
      } else {
        window.scrollTo(0, top);
      }
    });
  };

  // ─── Form submission (Shopify AJAX add-to-cart) ────────────────────
  BirthDataForm.prototype.onSubmit = function () {
    this.submitAttempted = true;
    this._tryAutoAcceptExact();
    if (!this.validate()) {
      this._showBlockedFeedback();
      return;
    }
    this._trackMilestone("wd_form_completed");

    var self = this;
    var birthDateProperties = this._birthDateProperties();

    // Strategy 1: If widget lives inside a Shopify product form, inject
    // hidden inputs and let the native form submit.
    var productForm = this.container.closest("form[action*='/cart/add']");
    if (productForm) {
      this._injectHiddenInputs(productForm);
      this.submitBtn.setAttribute("disabled", "disabled");
      this.submitBtn.textContent = this.t("cta_adding");
      productForm.submit();
      return;
    }

    // Strategy 2: AJAX add-to-cart mimicking the theme's native approach.
    // We use the same sections parameter and event dispatch as the theme.
    var productSection = this.container.closest("[data-product]") ||
      this.container.closest(".product") ||
      this.container.closest("form") ||
      document;
    var variantInput = productSection.querySelector(
      'select[name="id"], input[name="id"]'
    );
    if (!variantInput) {
      alert(this.t("alert_variant"));
      return;
    }

    // Collect section IDs for cart components (same as theme does)
    var sectionIds = [];
    document.querySelectorAll("cart-items-component").forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) {
        sectionIds.push(el.dataset.sectionId);
      }
    });

    // Build FormData (same format as theme's product-form.js). Wire shape
    // (multibrand M1, backend docs/reference/line-item-properties.md): the
    // locale-owned DISPLAY key directly followed by its canonical hidden
    // twin, both written from ONE shared value (coherence by construction);
    // untimed lines pin the present-empty canonical time (_birth_time: "").
    var clientNameValue = this.nameInput.value.trim();
    var birthTimeValue = this.isEssential ? "" : this.timeInput.value;
    var birthPlaceValue = this.hiddenFields.birthPlace.value;
    var formData = new FormData();
    formData.append("id", variantInput.value);
    formData.append("quantity", "1");
    formData.append(this.propNames.clientName, clientNameValue);
    formData.append("properties[_client_name]", clientNameValue);
    formData.append(birthDateProperties.visible.name, birthDateProperties.visible.value);
    formData.append(birthDateProperties.iso.name, birthDateProperties.iso.value);
    formData.append(this.propNames.birthTime, birthTimeValue);
    formData.append("properties[_birth_time]", birthTimeValue);
    formData.append(this.propNames.birthPlace, birthPlaceValue);
    formData.append("properties[_birth_place]", birthPlaceValue);
    formData.append("properties[_latitude]", this.hiddenFields.latitude.value);
    formData.append("properties[_longitude]", this.hiddenFields.longitude.value);
    formData.append("properties[_timezone]", this.hiddenFields.timezone.value);
    formData.append("properties[_order_key]", this._orderKey());
    if (sectionIds.length) {
      formData.append("sections", sectionIds.join(","));
    }

    this.submitBtn.setAttribute("disabled", "disabled");
    this.submitBtn.textContent = this.t("cta_adding");

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { "Accept": "text/html" },
    })
      .then(function (resp) {
        if (!resp.ok) throw new Error(self.t("error_add_failed"));
        return resp.json();
      })
      .then(function (response) {
        self._trackMilestone("wd_add_to_cart_ok");
        self.submitBtn.textContent = self.t("cta_added");
        setTimeout(function () {
          self.submitBtn.textContent = self.defaultCtaLabel || self.t("cta_chart");
          self.submitBtn.removeAttribute("disabled");
        }, 2000);

        // Dispatch the same "cart:update" event the theme uses
        var event = new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: variantInput.value,
            data: {
              source: "astro-birth-form",
              itemCount: 1,
              sections: response.sections || {},
            },
          },
        });
        document.dispatchEvent(event);
      })
      .catch(function (err) {
        self._trackMilestone("wd_add_to_cart_failed");
        alert(self.t("alert_add_prefix") + err.message);
        self.submitBtn.textContent = self.defaultCtaLabel || self.t("cta_chart");
        self.submitBtn.removeAttribute("disabled");
      });
  };

  // Unique per submission so two adds with identical birth details can never
  // merge into one cart line at quantity 2. The backend accepts ONLY quantity
  // 1 per report line (webhook parser), so a merged line fails after payment.
  // Underscore properties are hidden from cart display and checkout, and the
  // backend parser ignores property names it doesn't know.
  BirthDataForm.prototype._orderKey = function () {
    return (
      Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8)
    );
  };

  BirthDataForm.prototype._injectHiddenInputs = function (form) {
    // Remove previously injected inputs
    form.querySelectorAll(".astro-injected").forEach(function (el) {
      el.remove();
    });

    var birthDateProperties = this._birthDateProperties();
    // Same 12-key wire shape as the AJAX path: display key + canonical twin
    // from one shared value; the live _astro_* inputs never post properties,
    // so each property name occurs exactly once in the request (plan D1).
    var injClientName = this.nameInput.value.trim();
    var injBirthTime = this.isEssential ? "" : this.timeInput.value;
    var injBirthPlace = this.hiddenFields.birthPlace.value;
    var fields = [
      { name: this.propNames.clientName, value: injClientName },
      { name: "properties[_client_name]", value: injClientName },
      birthDateProperties.visible,
      birthDateProperties.iso,
      { name: this.propNames.birthTime, value: injBirthTime },
      { name: "properties[_birth_time]", value: injBirthTime },
      { name: this.propNames.birthPlace, value: injBirthPlace },
      { name: "properties[_birth_place]", value: injBirthPlace },
      { name: "properties[_latitude]", value: this.hiddenFields.latitude.value },
      {
        name: "properties[_longitude]",
        value: this.hiddenFields.longitude.value,
      },
      {
        name: "properties[_timezone]",
        value: this.hiddenFields.timezone.value,
      },
      { name: "properties[_order_key]", value: this._orderKey() },
    ];

    fields.forEach(function (f) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = f.name;
      input.value = f.value;
      input.className = "astro-injected";
      form.appendChild(input);
    });
  };

  // ─── Cleanup ─────────────────────────────────────────────────────
  BirthDataForm.prototype.destroy = function () {
    if (this._onDocumentClick) {
      document.removeEventListener('click', this._onDocumentClick);
      this._onDocumentClick = null;
    }
    if (this.map) {
      this.map.remove();
      this.map = null;
      this.marker = null;
    }
  };

  // ─── Auto-initialize ──────────────────────────────────────────────
  function init() {
    var containers = document.querySelectorAll("[id='astro-birth-form']");
    containers.forEach(function (container) {
      if (!container._astroBirthForm) {
        container._astroBirthForm = new BirthDataForm(container);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Expose constructor for manual instantiation and tests
  BirthDataForm._test = {
    createMilestoneTracker: createMilestoneTracker,
    defaultMilestoneEmit: defaultMilestoneEmit,
    createBirthDateHelpers: createBirthDateHelpers,
    createBirthTimeHelpers: createBirthTimeHelpers,
    cleanPlaceQuery: cleanPlaceQuery,
    findExactPlaceMatch: findExactPlaceMatch,
    placeDisplayString: placeDisplayString,
    computeCenteredScrollTop: computeCenteredScrollTop,
    scheduleAfterKeyboardSettles: scheduleAfterKeyboardSettles,
    EN_DEFAULT: EN_DEFAULT,
    fillTemplate: fillTemplate,
    loadFormConfig: loadFormConfig,
    makeT: makeT,
  };
  window.AstroBirthDataForm = BirthDataForm;
})();
